<template>
	<modal
		:title="title"
		:first-button-text="firstButtonText"
		:is-loading="isLoading"
		:first-button-action="firstButtonAction"
		:dark-theme="darkTheme"
		@close="closeModal"
	>
		<div v-if="description">
			{{ description }}
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue'

export default {
	name: 'UnavailabilityInfoModal',

	components: { Modal },

	props: {
		isLoading: {
			type: Boolean,
			default: false
		},

		title: {
			type: String,
			default: ''
		},

		firstButtonText: {
			type: String,
			default: 'OK'
		},

		firstButtonAction: {
			type: Function,
			default: () => {}
		},

		description: {
			type: String,
			default: ''
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	methods: {
		closeModal() {
			this.$emit('close')
		}
	}
}
</script>
